import { useQuery } from "@tanstack/react-query";
import { useTeamList } from "./useTeamList.ts";

export const useTeam = (teamId?: string) => {
  const teams = useTeamList();

  return useQuery({
    queryKey: ["team", { teamId }],
    queryFn: () => {
      if (!teams.isSuccess) {
        throw new Error("teamId not set");
      }

      return teams.data.teams.find((t) => t.id === teamId);
    },
    enabled: !!teamId && teams.isSuccess,
  });
};
